module.exports = __webpack_public_path__ + "img/spot.5c01a80c.svg";